<template>
  <div class="achievement-student">
    <el-button class="back" @click="$router.back()" size="small"
      >返回</el-button
    >
    <achievementInfo
      :examDetails="examDetails"
      v-if="studentScoreDesc"
      @derivedScore="derivedScore"
    />
    <achievementTable
      :examDetails="examDetails"
      :studentInfo="studentInfo"
      @barChartDialogShow="barChartDialogShow"
    />
    <barChartDialog
      v-show="chartDialogShow"
      :chartDialogShow.sync="chartDialogShow"
      :courseScoreList="courseScoreList"
    />
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
import achievementInfo from "./components/achievement-info/achievement-info.vue";
import achievementTable from "./components/achievement-table/achievement-table.vue";
import barChartDialog from "./components/bar-chart-dialog/barChartDialog.vue";

export default {
  name: "",
  data() {
    return {
      studentScoreDesc: false,
      examDetails: [
        {
          title: "", // 考试标题
          subTitle: "", // 考试副标题
          date: "", // 考试时间
          ranks: "", // 排名
          totalScore: "", // 总分
          avgScore: "", // 平均分
          classTotal: 0, // 班级人数
        },
      ],
      // 上一个页面传递的参数
      studentInfo: {
        id: "", //考试信息id
        studentNumber: "",
        studentName: "",
        headPortrait: "",
      },
      chartDialogShow: false,
      courseScoreList: [],
    };
  },
  components: {
    achievementInfo,
    achievementTable,
    barChartDialog,
  },
  created() {
    this.studentInfo = this.$route.query;
    // console.log("this.studentInfo", this.studentInfo);
  },
  mounted() {
    // 查询学生成绩详情
    this.selectAllExamInfoByStudentId();
  },
  methods: {
    // 导出成绩
    derivedScore() {
      let action = `${baseURL}${this.$url.selectAllExamInfoByStudentIdExcelPC}?studentId=${this.studentInfo.studentId}`;
      window.open(action);
    },
    barChartDialogShow(row) {
      this.chartDialogShow = true;
      this.courseScoreList = row.examCourseList;
    },
    selectAllExamInfoByStudentId() {
      this.get(
        this.$url.selectAllExamInfoByStudentId +
          "?studentId=" +
          this.studentInfo.studentId
      )
        .then((res) => {
          // console.log("查询学生成绩详情=>", res);
          if (!res.data) {
            this.$message.warning("学生成绩详情为空");
            this.studentScoreDesc = false;
            return;
          }
          this.studentScoreDesc = true;

          // 考试信息
          this.examDetails = res.data;
          // console.log("examDetails", this.examDetails);
        })
        .catch((err) => {
          console.log("学生考试详情报错==>", err);
          this.$message.error("获取考试信息失败，请稍后再试");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievement-student.scss";
</style>
